import React from "react"
import styled from "@emotion/styled"
import useDarkMode from "use-dark-mode"

const DarkModeToggle = () => {
  const darkMode = useDarkMode(false)

  const DarkModeToggle = styled.div`
    @media (max-width: 46rem) {
      margin-left: 1rem;
    }

    @media (min-width: 46rem) {
      grid-column-end: span 2;
      display: inline-flex;
      align-items: stretch;
      justify-content: flex-end;
      margin-left: 0;
    }
  `

  const Toggle = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    display: inline-block;
    font-size: 1.45rem;
    line-height: 0.01rem;
    outline: none;
    cursor: pointer;

    svg {
      * {
        fill: rgb(0, 0, 0);
      }
    }

    &.bulb--on {
      position: relative;
      top: -0.25rem;
      margin-right: 0.2rem;

      @media (max-width: 46rem) {
        top: 0;
      }

      svg {
        height: 1.9rem;
      }
    }

    &.bulb--off {
      svg {
        height: 1.4rem;
      }
    }

    svg {
      height: 1.4rem;

      * {
        fill: rgb(60, 60, 60);
      }
    }
  `

  const Switch = styled.label`
    display: inline-block;
    cursor: pointer;
    margin-left: 0.35rem;
    margin-right: 0.35rem;
    width: 2.75rem;
    height: 1.75rem;
    border-radius: 1rem;
    display: inline-block;
    position: relative;
    /* background: rgb(210, 210, 210); */
    background: transparent;
    border: 0.135rem solid rgb(60, 60, 60);
    box-shadow: 0 8px 16px -1px rgba(0, 0, 0, 0.2);

    & + button {
      margin-left: 0.35rem;
    }

    input {
      display: none;

      & + div {
        animation: toLight 0.33s forwards 1;
      }

      &:checked {
        & + div {
          animation: toDark 0.33s forwards 1;
        }
      }
    }
  `

  const Ball = styled.div`
    display: block;
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    width: 1.05rem;
    height: 1.05rem;
    border-radius: 1rem;
    background-color: ${props => props.theme.primaryBlue};
    transform: translateX(0rem);
    will-change: transform;
    animation-play-state: paused;
  `

  return (
    <DarkModeToggle>
      <Toggle className="bulb--on" type="button" onClick={darkMode.disable}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
          <defs />
          <g fill-rule="nonzero">
            <path d="M42.6978874 27.7392817c0-7.9243226-6.4613708-14.4466496-14.4466497-14.4466496s-14.4466496 6.4613707-14.4466496 14.4466496c0 1.0972139.1219126 2.2553841.4266943 3.4135544.4876506 2.1944277 1.4019955 4.0231176 2.6820784 6.339458.6705196 1.2191266 1.3410392 1.9506025 1.8286898 2.4992095.7314759.7924322.8533886.9753012.8533886 2.3772967v3.2916417c0 1.4019956.7924322 2.5601658 1.9506025 3.1697291.6095632 4.0231176 2.4992094 6.5832833 6.705196 6.5832833s6.0956328-2.5601657 6.705196-6.5832833c1.1581703-.6095633 1.9506025-1.7677335 1.9506025-3.1697291v-3.2916417c0-1.4019955.182869-1.5848645.8533886-2.3772967.4876506-.548607 1.1581702-1.2800829 1.8286898-2.4992095 1.3410392-2.3163404 2.2553842-4.1450303 2.6820785-6.339458.3047816-1.1581703.4266943-2.3163405.4266943-3.4135544zm-9.5091872 14.8733439v2.9259038h-9.874925v-2.9259038h9.874925zm-4.9374625 9.0824929c-1.0362576 0-2.3163404 0-2.9259037-2.4992095h5.7908511c-.5486069 2.4992095-1.8286898 2.4992095-2.8649474 2.4992095zm10.4844884-21.395671c-.365738 1.7677335-1.1581703 3.2916417-2.3163405 5.3641568-.4876506.8533886-.9753012 1.4019955-1.4019955 1.8896462-.4266943.4876506-.7924323.9143449-1.0972139 1.4019955h-11.337877c-.3047816-.4876506-.6705196-.9753013-1.0972139-1.4019955-.4266943-.4876507-.8533885-.9753013-1.4019955-1.8896462-1.1581702-2.0115588-1.9506025-3.535467-2.3163404-5.3032005v-.0609563c-.2438254-.8533886-.3047817-1.7677335-.3047817-2.5601658 0-5.9127638 4.8155499-10.78927 10.78927-10.78927s10.78927 4.8155499 10.78927 10.78927c0 .7924323-.1219127 1.6458209-.3047816 2.5601658zM53.974808 25.8496355h-4.449812c-1.0362575 0-1.8286898.7924323-1.8286898 1.8286899 0 1.0362575.7924323 1.8286898 1.8286898 1.8286898h4.449812c1.0362575 0 1.8286898-.7924323 1.8286898-1.8286898 0-1.0362576-.8533886-1.8286899-1.8286898-1.8286899zM43.2464943 14.5117586c.4876506 0 .9143449-.182869 1.2800829-.5486069l3.169729-3.1697291c.7314759-.7314759.7314759-1.88964613 0-2.56016573-.7314759-.73147593-1.8896461-.73147593-2.5601657 0l-3.1697291 3.16972903c-.7314759.7314759-.7314759 1.8896462 0 2.5601658.365738.3657379.8533886.5486069 1.2800829.5486069zM28.2512377 8.29421319c1.0362576 0 1.8286898-.79243225 1.8286898-1.82868982V2.01571145c0-1.03625757-.7924322-1.82868983-1.8286898-1.82868983s-1.8286898.79243226-1.8286898 1.82868983v4.44981192c0 .97530124.7924322 1.82868982 1.8286898 1.82868982zM11.9758982 13.9631517c.365738.3657379.8533886.5486069 1.2800829.5486069.4266943 0 .9143449-.182869 1.2800829-.5486069.7314759-.731476.7314759-1.8896462 0-2.5601658l-3.169729-3.16972903c-.731476-.73147593-1.8896462-.73147593-2.56016581 0-.73147593.73147593-.73147593 1.88964613 0 2.56016573l3.16972901 3.1697291zM8.86712552 27.6783254c0-1.0362576-.79243226-1.8286899-1.82868983-1.8286899H2.58862378c-1.03625757 0-1.82868983.7924323-1.82868983 1.8286899 0 1.0362575.79243226 1.8286898 1.82868983 1.8286898h4.44981191c.97530125 0 1.82868983-.7924323 1.82868983-1.8286898zM11.9758982 41.3934991l-3.16972901 3.169729c-.73147593.731476-.73147593 1.8896462 0 2.5601658.36573797.365738.85338859.5486069 1.28008288.5486069.42669433 0 .91434493-.1828689 1.28008293-.5486069l3.169729-3.169729c.7314759-.731476.7314759-1.8896462 0-2.5601658-.7314759-.7314759-1.8896462-.7314759-2.5601658 0zM44.5265772 41.3934991c-.731476-.7314759-1.8896462-.7314759-2.5601658 0-.7314759.7314759-.7314759 1.8896461 0 2.5601658l3.1697291 3.169729c.3657379.365738.8533885.5486069 1.2800828.5486069.4266943 0 .9143449-.1828689 1.2800829-.5486069.7314759-.7314759.7314759-1.8896462 0-2.5601658l-3.169729-3.169729z" />
          </g>
        </svg>
      </Toggle>
      <Switch>
        <input
          type="checkbox"
          checked={darkMode.value}
          onChange={darkMode.toggle}
        />
        <Ball />
      </Switch>
      <Toggle className="bulb--off" type="button" onClick={darkMode.enable}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 43">
          <defs />
          <path
            fill-rule="nonzero"
            d="M29.6578724 14.7392817c0-7.92432259-6.4613708-14.44664964-14.4466497-14.44664964-7.98527891 0-14.44664964 6.46137073-14.44664964 14.44664964 0 1.0972139.12191265 2.2553841.42669429 3.4135544.48765062 2.1944277 1.40199554 4.0231176 2.68207842 6.339458.6705196 1.2191266 1.34103921 1.9506025 1.82868983 2.4992095.73147593.7924322.85338858.9753012.85338858 2.3772967v3.2916417c0 1.4019956.79243226 2.5601658 1.95060249 3.1697291.60956327 4.0231176 2.49920943 6.5832833 6.70519603 6.5832833 4.2059866 0 6.0956328-2.5601657 6.705196-6.5832833 1.1581703-.6095633 1.9506025-1.7677335 1.9506025-3.1697291v-3.2916417c0-1.4019955.182869-1.5848645.8533886-2.3772967.4876506-.548607 1.1581702-1.2800829 1.8286898-2.4992095 1.3410392-2.3163404 2.2553842-4.1450303 2.6820785-6.339458.3047816-1.1581703.4266943-2.3163405.4266943-3.4135544zm-9.5091872 14.8733439v2.9259038h-9.874925v-2.9259038h9.874925zm-4.9374625 9.0824929c-1.0362576 0-2.3163404 0-2.9259037-2.4992095h5.7908511c-.5486069 2.4992095-1.8286898 2.4992095-2.8649474 2.4992095zm10.4844884-21.395671c-.365738 1.7677335-1.1581703 3.2916417-2.3163405 5.3641568-.4876506.8533886-.9753012 1.4019955-1.4019955 1.8896462-.4266943.4876506-.7924323.9143449-1.0972139 1.4019955H9.54228424c-.30478164-.4876506-.67051961-.9753013-1.0972139-1.4019955-.42669429-.4876507-.85338859-.9753013-1.40199554-1.8896462-1.15817022-2.0115588-1.95060248-3.535467-2.31634045-5.3032005v-.0609563c-.24382531-.8533886-.30478163-1.7677335-.30478163-2.5601658 0-5.91276377 4.81554988-10.78926998 10.78926998-10.78926998s10.78927 4.81554988 10.78927 10.78926998c0 .7924323-.1219127 1.6458209-.3047816 2.5601658z"
          />
        </svg>
      </Toggle>
    </DarkModeToggle>
  )
}

export default DarkModeToggle
